import type { SelectionFlag } from './placeholderTypes';

export type PlaceholderSegment =
  | { type: 'text'; text: string }
  | { type: 'selectionList'; flag: SelectionFlag; name: string }
  | { type: 'textMark'; name: string };

// [[E:Name]] / [[M:Name]] = selection lists; [[T:Name]] and empty [[]] = free-text (text mark).
// Names never contain "]". A [[…]] with content but no E/M/T flag stays literal text.
const TOKEN_RE = /\[\[([MET]):([^\]]+)\]\]|\[\[\]\]/g;

export function selectionListToken(flag: SelectionFlag, name: string): string {
  return `[[${flag}:${name}]]`;
}

export function textMarkToken(name: string): string {
  return name.length > 0 ? `[[T:${name}]]` : '[[]]';
}

export function splitPlaceholderTokens(text: string): PlaceholderSegment[] {
  const segments: PlaceholderSegment[] = [];
  let lastIndex = 0;
  TOKEN_RE.lastIndex = 0;
  for (let match = TOKEN_RE.exec(text); match !== null; match = TOKEN_RE.exec(text)) {
    if (match.index > lastIndex) {
      segments.push({ type: 'text', text: text.slice(lastIndex, match.index) });
    }
    const flag = match[1];
    const name = match[2];
    if (flag === undefined) {
      segments.push({ type: 'textMark', name: '' });
    } else if (flag === 'T') {
      segments.push({ type: 'textMark', name });
    } else {
      segments.push({ type: 'selectionList', flag: flag as SelectionFlag, name });
    }
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    segments.push({ type: 'text', text: text.slice(lastIndex) });
  }
  return segments;
}
